export default {
  feature: {
    dataView: {
      show: false
    },
    magicType: {
      show: false
    },
    restore: {
      show: false
    },
    saveAsImage: {
      show: false,
      name: '地图',
      pixelRatio: 2
    }
  },
  iconStyle: {
    normal: {
      borderColor: '#1990DA'
    }
  },
  itemSize: 15,
  top: 20,
  right: 22
}



// WEBPACK FOOTER //
// ./src/views/home/board/options/toolbox.js